// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';

// import './router/permission'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import http from '@/api/request'
Vue.prototype.$axios = axios 
Vue.prototype.$http = http

Vue.config.productionTip = false


Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store  
})


//设置根元素大小
function onResize() {
  let screenWeight = document.documentElement.clientWidth;
  if (screenWeight<960) screenWeight=960
  let rate = screenWeight/960*12;
  document.documentElement.style.fontSize = rate+'px';
}
onResize();
window.addEventListener('resize',onResize);


// WEBPACK FOOTER //
// ./src/main.js